import PageTitle from '@/components/PageTitle';
import { ReactNode } from 'react';
import FallbackRoute from './FallbackRoute';

interface IProps {
  token: string;
  children: ReactNode;
}

const AuthRoute = ({ token, children }: IProps) => {
  if (token) return <FallbackRoute token={token} />;
  return (
    <>
      <PageTitle />
      {children}
    </>
  );
};

export default AuthRoute;
